import { Component, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { hasError: boolean; message: string | null };

export class ProtectedErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: null };

  static getDerivedStateFromError(err: Error): State {
    return { hasError: true, message: err.message };
  }

  componentDidCatch(error: Error) {
    console.error("ProtectedErrorBoundary caught:", error);
  }

  reset = () => this.setState({ hasError: false, message: null });

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
        <div className="max-w-md w-full bg-white border border-red-300 rounded-lg p-6 text-center">
          <h2 className="text-lg font-semibold text-red-700 mb-2">Dashboard error</h2>
          <p className="text-sm text-slate-600 mb-4">
            {this.state.message ?? "Something went wrong while rendering this page."}
          </p>
          <button
            onClick={this.reset}
            className="px-4 py-2 text-sm rounded bg-slate-900 text-white hover:bg-slate-800"
          >
            Try again
          </button>
        </div>
      </div>
    );
  }
}
